"use strict";

define('components/filter_bar/filters/alpha_filters',[], function() {
    var alphaFiltersComponent = {
        initWithContext: function(context) {
            // TODO: This component's DOM queries
            // should be scoped to context.containerNode
            // Need to check DOM placement of #show-alpha-filters

            var revealer = $('#show-alpha-filters');
            revealer.click(function() {
                var filtersNode = $('#alpha-filters');
                var activeNodes = filtersNode.find('li.active:not(.all)');
                if (!activeNodes[0]) {
                    revealer.toggleClass('btn-info')
                            .toggleClass('selected');
                }
                filtersNode.toggleClass('hidden');
            });
        }
    };

    return alphaFiltersComponent;
});
